/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online color converter. Convert between HEX, RGB and HSL, pick a color with the colour picker, and copy any format with a live preview.`)
};

const es_cv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor de colores en línea gratuito. Convierte entre HEX, RGB e HSL, elige un color con el selector de color y copia cualquier formato con una vista previa en vivo.`)
};

const de_cv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Farbkonverter. Konvertieren Sie zwischen HEX, RGB und HSL, wählen Sie eine Farbe mit der Farbauswahl aus und kopieren Sie jedes Format mit einer Live-Vorschau.`)
};

const nl_cv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online kleurconverter. Converteer tussen HEX, RGB en HSL, kies een kleur met de kleurkiezer en kopieer elk formaat met een live voorbeeld.`)
};

const fr_cv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de couleurs gratuit en ligne. Convertissez entre HEX, RGB et HSL, choisissez une couleur avec le sélecteur de couleur, et copiez n'importe quel format avec un aperçu en direct.`)
};

const it_cv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di colori online gratuito. Converti tra HEX, RGB e HSL, scegli un colore con la tavolozza colori e copia qualsiasi formato con un'anteprima dal vivo.`)
};

const pt_br2_cv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de cores gratuito online. Converta entre HEX, RGB e HSL, escolha uma cor com o seletor de cores e copie qualquer formato com visualização ao vivo.`)
};

const pt_cv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de cores em linha gratuito. Converta entre HEX, RGB e HSL, escolha uma cor com o selector de cores e copie qualquer formato com uma pré-visualização em direto.`)
};

const ja_cv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンライン色変換ツール。HEX、RGB、HSLの間で変換し、カラーピッカーで色を選択し、ライブプレビュー付きで任意の形式をコピーします。`)
};

const zh_cv_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线颜色转换器。在HEX、RGB和HSL之间转换，使用取色器选取颜色，并通过实时预览复制任意格式。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cv_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cv_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cv_meta_description", locale)
	if (locale === "en") return en_cv_meta_description(inputs)
	if (locale === "es") return es_cv_meta_description(inputs)
	if (locale === "de") return de_cv_meta_description(inputs)
	if (locale === "nl") return nl_cv_meta_description(inputs)
	if (locale === "fr") return fr_cv_meta_description(inputs)
	if (locale === "it") return it_cv_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_cv_meta_description(inputs)
	if (locale === "pt") return pt_cv_meta_description(inputs)
	if (locale === "ja") return ja_cv_meta_description(inputs)
	return zh_cv_meta_description(inputs)
};